import {Typography, TypographyPropsVariantOverrides} from '@mui/material';
import {Variant} from '@mui/material/styles/createTypography';
import {OverridableStringUnion} from '@mui/types';

export interface TextComponentProps {
    content: string;
    color?: string | undefined;
    fontWeight: number;
    variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>;
    marginBottom?: number;
}

export const TextComponent = ({content, color, fontWeight, variant, marginBottom}: TextComponentProps) => {
    const paragraphs = content.split('\n').map((paragraph) => {
        return (
            <Typography
                component={'div'}
                variant={variant}
                style={{
                    color: color ?? 'black',
                    fontWeight: fontWeight,
                    fontFamily: 'Poppins',
                    marginBottom: marginBottom ? marginBottom : 12,
                }}>
                {paragraph}
            </Typography>
        );
    });

    return <>{paragraphs}</>;
};
